import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkRideStatusNew = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const bulkStatusNewRidesProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkRideStatusNew,
    entity,
  );
  const bulkStatusNewRidesProcess = useRecoilValue(
    activeProcessSF(bulkStatusNewRidesProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkRideStatusNew,
      toastSummaryOnComplete: true,
      process: bulkStatusNewRidesProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
    });
  }, [bulkStatusNewRidesProcess, entity, onComplete, stopProcessPolling, t]);
};
